export const dancingBarsNumber = 50
